/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Box, Grid, Paper, Typography } from '@material-ui/core';
import CalenderRange from '../../components/fields/CalenderRange';
import { covertToDate } from '../../Shared/colorFormat';
import PackageItems from '../../Shared/PackageItems';

const CollectiveitemsAlsardal = (props: any) => {
  const { start, setStart, setEnd, isRTL, collectiveitemslist } = props;
  const title = `${covertToDate(start)}`;
  return (
    <Paper
      elevation={2}
      style={{
        height: 300,
        overflow: 'auto',
        margin: 20,
      }}
    >
      <Grid container spacing={0}>
        <Grid item xs={9}>
          <Box p={2}>
            <Typography
              variant="h5"
              style={{ padding: 10, fontWeight: 'bold' }}
            >
              {isRTL ? 'الباكجات' : 'Packages'}
            </Typography>
            <Grid container spacing={2}>
              {collectiveitemslist?.length > 0 &&
                collectiveitemslist?.map((item: any) => (
                  <Grid item xs={3}>
                    <PackageItems
                      isRTL={isRTL}
                      pack={item}
                      items={item.items}
                    ></PackageItems>
                  </Grid>
                ))}
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={3} style={{ marginTop: 20 }}>
          <CalenderRange
            label={title}
            setStart={setStart}
            setEnd={setEnd}
            isRTL={isRTL}
            start={start}
          ></CalenderRange>
        </Grid>
      </Grid>
    </Paper>
  );
};
export default CollectiveitemsAlsardal;
